<div class="content-plan">
  <div class="content-form">

    <div>
      <button (click)="dialogRef.close()" class="btn-default btn"   style="float: right; background : #15448f; color: white;">X</button>
    </div>

    <div class="rendered-form form-pay">
      <div class="description-payment">
        <p style="text-align:left">{{ 'paymentPopup.description' | translate:{ fee: feeCostPlan } }}</p>

        <b>{{ 'paymentPopup.benefitsTitle' | translate }}</b>

        <ul>
          <li> <mat-icon class="check">check_circle</mat-icon>{{ 'paymentPopup.benefits.recurringBilling' | translate }}</li>

          <li><mat-icon class="check">check_circle</mat-icon>{{ 'paymentPopup.benefits.failedRetries' | translate }}</li>

          <li><mat-icon class="check">check_circle</mat-icon>{{ 'paymentPopup.benefits.autoComms' | translate }}</li>

          <li><mat-icon class="check">check_circle</mat-icon>{{ 'paymentPopup.benefits.optionalPortal' | translate }}</li>

          <li><mat-icon class="check">check_circle</mat-icon>{{ 'paymentPopup.benefits.dailyReports' | translate }}</li>
        </ul>

      </div>

      <form [formGroup]="form" (ngSubmit)="send()">
        <h2>{{ 'paymentPopup.title' | translate }}</h2>
        <p>{{ 'paymentPopup.subtitle' | translate }}</p>

        <!-- Nombre del tarjetahabiente -->
        <div class="form-group field-tc full-width">
          <label for="nombreTitular">{{ 'paymentPopup.form.cardholderName' | translate }}</label>
          @if (form.controls['nameHolderCreditCard'].hasError('required') && form.controls['nameHolderCreditCard'].touched) {
            <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }} </small>
          }
          <input [formControl]="form.controls['nameHolderCreditCard']" type="text" [placeholder]="'paymentPopup.form.placeholders.cardholderName' | translate" class="form-control" name="cc-name" access="false" id="nombreTitular" required="required" aria-required="true" autocomplete="cc-name">
        </div>

        <!-- Número de Tarjeta -->
        <div class="two-column">
          <div class="form-group full-width">
            <label for="Numero-de-Tarjeta">{{ 'paymentPopup.form.cardNumber' | translate }}</label>
            @if (form.controls['numberCreditCard'].hasError('required') && form.controls['numberCreditCard'].touched) {
              <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }}</small>
            }
            @if (form.controls['numberCreditCard'].hasError('pattern') && form.controls['numberCreditCard'].touched) {
              <small class="form-error-msg"> {{ 'paymentPopup.errors.numbersOnly' | translate }}</small>
            }
            @if (form.controls['numberCreditCard'].hasError('invalidLength') && form.controls['numberCreditCard'].touched) {
              <small class="form-error-msg"> {{ 'paymentPopup.errors.cardNumberLength' | translate }}</small>
            }
            @if (form.controls['numberCreditCard'].hasError('invalidCardNumber') && form.controls['numberCreditCard'].touched) {
              <small class="form-error-msg"> {{ 'paymentPopup.errors.cardNumberInvalid' | translate }}</small>
            }
            <img style="height: 20px;" src="../assets/images/visa-mastercard.png" alt="">
            <input
              (keypress)="onlyNumberKey($event)"
              (input)="formatCreditCardNumber()"
              [formControl]="form.controls['numberCreditCard']"
              type="text"
              [placeholder]="'paymentPopup.form.placeholders.cardNumber' | translate"
              class="form-control"
              name="cc-number"
              access="false"
              id="Numero-de-Tarjeta"
              required="required"
              aria-required="true"
              autocomplete="cc-number">
            </div>

            <!-- CCV -->
            <div class="form-group full-width">
              <label for="CCV">{{ 'paymentPopup.form.ccv' | translate }}</label>
              @if (form.controls['ccv'].hasError('pattern') && form.controls['ccv'].touched) {
                <small class="form-error-msg"> {{ 'paymentPopup.errors.numbersOnly' | translate }}</small>
              }
              @if (form.controls['ccv'].hasError('maxlength') && form.controls['ccv'].touched) {
                <small class="form-error-msg"> {{ 'paymentPopup.errors.ccvMaxLength' | translate }}</small>
              }
              <input
                (keypress)="onlyNumberKey($event)"
                [formControl]="form.controls['ccv']"
                type="password"
                maxlength="4"
                [placeholder]="'paymentPopup.form.placeholders.ccv' | translate"
                class="form-control"
                name="cc-csc"
                autocomplete="cc-csc"
                access="false"
                id="CCV">
              </div>

              <!-- Mes de Expiración -->
              <div class="form-group full-width">
                <label for="mes-exp">{{ 'paymentPopup.form.expMonth' | translate }}</label>
                @if (form.controls['expMonthCreditCard'].hasError('required') && form.controls['expMonthCreditCard'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }}</small>
                }
                <select [formControl]="form.controls['expMonthCreditCard']" class="form-control" name="cc-exp-month" autocomplete="cc-exp-month" id="mes-exp">
                  <option disabled="" selected="" value="">{{ 'paymentPopup.form.expMonthPlaceholder' | translate }}</option>
                  <option value="01" id="mes-exp-0">{{ 'paymentPopup.form.months.january' | translate }}</option>
                  <option value="02" id="mes-exp-1">{{ 'paymentPopup.form.months.february' | translate }}</option>
                  <option value="03" id="mes-exp-2">{{ 'paymentPopup.form.months.march' | translate }}</option>
                  <option value="04" id="mes-exp-3">{{ 'paymentPopup.form.months.april' | translate }}</option>
                  <option value="05" id="mes-exp-4">{{ 'paymentPopup.form.months.may' | translate }}</option>
                  <option value="06" id="mes-exp-5">{{ 'paymentPopup.form.months.june' | translate }}</option>
                  <option value="07" id="mes-exp-6">{{ 'paymentPopup.form.months.july' | translate }}</option>
                  <option value="08" id="mes-exp-7">{{ 'paymentPopup.form.months.august' | translate }}</option>
                  <option value="09" id="mes-exp-8">{{ 'paymentPopup.form.months.september' | translate }}</option>
                  <option value="10" id="mes-exp-9">{{ 'paymentPopup.form.months.october' | translate }}</option>
                  <option value="11" id="mes-exp-10">{{ 'paymentPopup.form.months.november' | translate }}</option>
                  <option value="12" id="mes-exp-11">{{ 'paymentPopup.form.months.december' | translate }}</option>
                </select>
              </div>

              <!-- Año de Expiración -->
              <div class="form-group half-width">
                <label for="ano-exp">{{ 'paymentPopup.form.expYear' | translate }}</label>
                @if (form.controls['expYearCreditCard'].hasError('required') && form.controls['expYearCreditCard'].touched) {
                  <small class="form-error-msg">{{ 'paymentPopup.errors.required' | translate }} </small>
                }
                <select [formControl]="form.controls['expYearCreditCard']" class="form-control" name="cc-exp-year" autocomplete="cc-exp-year" id="ano-exp">
                  <option disabled selected value="">{{ 'paymentPopup.form.expYearPlaceholder' | translate }}</option>
                  @for (year of expirationYears; track year) {
                    <option [value]="year.value">
                      {{ year.label }}
                    </option>
                  }
                </select>
              </div>

              <!-- Ciudad -->
              <div class="form-group full-width">
                <label for="city">{{ 'paymentPopup.form.city' | translate }}</label>
                @if (form.controls['city'].hasError('required') && form.controls['city'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }} </small>
                }
                <input [formControl]="form.controls['city']" type="text" [placeholder]="'paymentPopup.form.placeholders.city' | translate" class="form-control" name="cc-city" access="false" id="city" required="required" aria-required="true" autocomplete="cc-city">
              </div>

              <!-- Calle -->
              <div class="form-group full-width">
                <label for="street">{{ 'paymentPopup.form.street' | translate }}</label>
                @if (form.controls['street'].hasError('required') && form.controls['street'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }} </small>
                }
                <input [formControl]="form.controls['street']" type="text" [placeholder]="'paymentPopup.form.placeholders.street' | translate" class="form-control" name="cc-street" access="false" id="street" required="required" aria-required="true" autocomplete="cc-street">
              </div>

              <!-- Código Postal -->
              <div class="form-group full-width">
                <label for="postalCode">{{ 'paymentPopup.form.postalCode' | translate }}</label>
                @if (form.controls['postalCode'].hasError('required') && form.controls['postalCode'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }} </small>
                }
                @if (form.controls['postalCode'].hasError('pattern') && form.controls['postalCode'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.invalidFormat' | translate }} </small>
                }
                <input [formControl]="form.controls['postalCode']" type="text" [placeholder]="'paymentPopup.form.placeholders.postalCode' | translate" class="form-control" name="cc-postalCode" access="false" id="postalCode" required="required" aria-required="true" autocomplete="cc-postalCode" (keypress)="onlyNumberKey($event)">
              </div>
              <!-- Teléfono -->
              <div class="form-group full-width">
                <label for="phone">{{ 'paymentPopup.form.phone' | translate }} </label>
                @if (form.controls['phone'].hasError('required') && form.controls['phone'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.required' | translate }} </small>
                }
                @if (form.controls['phone'].hasError('pattern') && form.controls['phone'].touched) {
                  <small class="form-error-msg"> {{ 'paymentPopup.errors.invalidFormat' | translate }} </small>
                }
                <input [formControl]="form.controls['phone']" type="text" [placeholder]="'paymentPopup.form.placeholders.phone' | translate" class="form-control" name="cc-phone" access="false" id="phone" required="required" aria-required="true" autocomplete="cc-phone" (keypress)="onlyNumberKey($event)">
              </div>


            </div>

            <!-- Botón de Suscripción -->
            <div class="form-group">
              <button type="submit" class="btn-default btn" name="suscribirte" access="false" id="suscribirte">{{ 'paymentPopup.actions.subscribe' | translate }}</button>
            </div>
          </form>




        </div>

      </div>
    </div>
